function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7861c754\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/root/workspace/er-release_sustaining_6.5.x-3N4P6NGXBXNUK6P6YS6NH3HTBRIFUA44HVNUBWXAYGMSAMOC6RBA/node_modules/bootstrap/scss/_functions.scss\",\"/root/workspace/er-release_sustaining_6.5.x-3N4P6NGXBXNUK6P6YS6NH3HTBRIFUA44HVNUBWXAYGMSAMOC6RBA/node_modules/bootstrap/scss/_mixins.scss\",\"/root/workspace/er-release_sustaining_6.5.x-3N4P6NGXBXNUK6P6YS6NH3HTBRIFUA44HVNUBWXAYGMSAMOC6RBA/node_modules/bootstrap/scss/_variables.scss\",\"/root/workspace/er-release_sustaining_6.5.x-3N4P6NGXBXNUK6P6YS6NH3HTBRIFUA44HVNUBWXAYGMSAMOC6RBA/src/scss/theme-variables.scss\"]}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UserDetails.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserDetails.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7861c754\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserDetails.vue"
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7861c754"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/selfservice/registration/UserDetails.vue
// module id = null
// module chunks = 